<template>
  <li
    role="presentation"
    class="eds-tab"
    :class="[{ 'tab-selected': index === value }]"
    :key="index"
  >
    <a
      class="tab-content eds-link"
      :class="[{ 'link-selected': index === value }]"
      :aria-selected="index === value"
      @click="clickHandler"
    >
      <slot name="icon" />
      <span class="tab-label"><slot /></span>
    </a>
    <button
      id="tabCloseButton"
      v-if="closable"
      :title="closeButtonTitle"
      class="tab-close eds-link"
      @click="closeHandler"
    >
      <slot name="closeIcon">
        <svg
          class="tab-icon"
          viewBox="0 0 24 24"
        >
          <path
            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
          ></path>
        </svg>
      </slot>
    </button>
  </li>
</template>
<script lang="ts">
  import { defineComponent, toRefs } from 'vue';
  export default defineComponent({
    name: 'Tab',
    emits: ['tabClick', 'close'],
    props: {
      value: {
        type: Number,
        required: false,
        default: 0,
      },
      index: {
        type: Number,
        required: false,
        default: 0,
      },
      closable: {
        type: Boolean,
        required: false,
        default: true,
      },
      closeButtonTitle: {
        type: String,
        required: false,
        default: 'close',
      },
    },
    setup: (props, { emit }) => {
      const { index } = toRefs(props);

      const clickHandler = (): void => {
        emit('tabClick', index.value);
      };

      const closeHandler = (): void => {
        emit('close', index.value);
      };

      return {
        clickHandler,
        closeHandler,
      };
    },
  });
</script>
